import { render } from "./RatingStars.vue?vue&type=template&id=77a790a0&scoped=true"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"

import "./RatingStars.vue?vue&type=style&index=0&id=77a790a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a790a0"]])

export default __exports__